/* eslint-disable camelcase */
import axios from 'axios';
import {baseEnvironment} from '../environment/environment.base';

const physicianAllRoute =  `/${baseEnvironment.apiVersion1}${baseEnvironment.apiEndPoints.physicians.all}`;
const physicianRoute =  `/${baseEnvironment.apiVersion1}${baseEnvironment.apiEndPoints.physicians.physician}`;

/* Find all users */
export const getAllPhysicians = async (): Promise<any> => {
  const response = await axios.get(`${physicianAllRoute}`);
  return response.data;
};

export const getPhysician = async (id: any): Promise<any> => {
  const response = await axios.get(`${physicianRoute}/${id}`);
  return response.data;
};

export const createPhysician = async (id: any, object: any): Promise<any> => {
  const response = await axios.post(`${physicianRoute}/${id}`, object);
  return response.data;
};

export const updatePhysician = async (id: any, object: any): Promise<any> => {
  const response = await axios.put(`${physicianRoute}/${id}`, object);
  return response.data;
};

export const deletePhysician = async (id: any): Promise<any> => {
  const response = await axios.delete(`${physicianRoute}/${id}`);
  return response.data;
};